import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root: {
        position: 'relative',
        flex: 1,
    },
    line:{
        zIndex:1,
    },
    inner:{
        minHeight:'150px'
    }
}